'use strict';

var React = require('react');

var SvgDomainRedirectIcon = function SvgDomainRedirectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3c-.414 0-.75.336-.75.75v9c0 .414.336.75.75.75s.75-.336.75-.75v-8.25h9.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 6.25c0-.414.336-.75.75-.75h10.5c.414 0 .75.336.75.75v4c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.75h-9v5h2.75c.414 0 .75.336.75.75s-.336.75-.75.75h-3.5c-.414 0-.75-.336-.75-.75v-9Zm10.5.75v1h-9v-1h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.902c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.243l-.591-.591c-.293-.293-.293-.768 0-1.061.293-.293.767-.293 1.06 0l1.872 1.871c.293.293.293.768 0 1.061l-1.872 1.871c-.293.293-.768.293-1.06 0-.293-.293-.293-.767 0-1.06l.59-.591h-3.242Z"
  }));
};
SvgDomainRedirectIcon.displayName = "DomainRedirectIcon";

exports.SvgDomainRedirectIcon = SvgDomainRedirectIcon;
